// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureBar_root__i3BBj"};